export enum BonLivraisonStatus {
  EN_COURS = 'en_cours',
  LIVRE = 'livre',
  ANNULE = 'annule'
}

export interface BonLivraisonItem {
  id: number;
  bon_livraison_id: number;
  article_id?: number | null;
  designation: string;
  quantite: number;
  commentaire?: string | null;
  created_at: string;
}

export interface BonLivraisonItemCreate {
  article_id?: number | null;
  designation: string;
  quantite: number;
  commentaire?: string | null;
}

export interface BonLivraisonItemUpdate {
  id?: number | null;  // If provided, update existing item; if null, create new
  article_id?: number | null;
  designation: string;
  quantite: number;
  commentaire?: string | null;
}

export interface BonLivraison {
  id: number;
  reference: string;
  date: string;
  client_id: number;
  bon_commande_number?: string | null;
  transporteur_nom?: string | null;
  transporteur_matricule?: string | null;
  transporteur_cin?: string | null;
  condition_remarque?: string | null;
  status: BonLivraisonStatus | string;
  user_id: number;
  created_at: string;
  updated_at?: string | null;
  deleted_at?: string | null;
  items: BonLivraisonItem[];
  // Related names
  client_name?: string | null;
  client_ice?: string | null;
  client_address?: string | null;
  user_name?: string | null;
}

export interface BonLivraisonCreate {
  date: string;
  client_id: number;
  bon_commande_number?: string | null;
  transporteur_nom?: string | null;
  transporteur_matricule?: string | null;
  transporteur_cin?: string | null;
  condition_remarque?: string | null;
  items: BonLivraisonItemCreate[];
}

export interface BonLivraisonUpdate {
  date: string;
  client_id: number;
  bon_commande_number?: string | null;
  transporteur_nom?: string | null;
  transporteur_matricule?: string | null;
  transporteur_cin?: string | null;
  condition_remarque?: string | null;
  status?: BonLivraisonStatus | string;
  items?: BonLivraisonItemUpdate[];
}

export interface BonLivraisonListResponse {
  total: number;
  items: BonLivraison[];
}
